// Insights — split from SponsorHQ.jsx
import { Activity } from "lucide-react";

export default function InsightsSection({ dash }) {
  const s = dash.summary;
  const totals = dash.campaigns.reduce((acc, c) => ({
    impressions: acc.impressions + (c.impressions || 0),
    clicks: acc.clicks + (c.clicks || 0),
    conv: acc.conv + (c.conversions || 0),
    spent: acc.spent + (c.spent || 0),
  }), { impressions: 0, clicks: 0, conv: 0, spent: 0 });

  const topCampaigns = [...dash.campaigns].sort((a, b) => (b.impressions || 0) - (a.impressions || 0)).slice(0, 5);

  return (
    <section className="space-y-6" data-testid="insights-section">
      <h2 className="font-display text-sm tracking-[0.3em] uppercase flex items-center gap-2"><Activity className="w-4 h-4 text-nexus-mint" /> Insights · lifetime performance</h2>

      <div className="grid sm:grid-cols-4 gap-px bg-white/5">
        <div className="bg-nexus-surface p-5">
          <div className="label-eyebrow">CPM</div>
          <div className="font-display font-black text-3xl mt-2 text-nexus-cyan">${s.cpm.toFixed(2)}</div>
        </div>
        <div className="bg-nexus-surface p-5">
          <div className="label-eyebrow">CPA</div>
          <div className="font-display font-black text-3xl mt-2 text-nexus-amber">${s.cpa.toFixed(2)}</div>
        </div>
        <div className="bg-nexus-surface p-5">
          <div className="label-eyebrow">avg CTR</div>
          <div className="font-display font-black text-3xl mt-2 text-nexus-magenta">{s.avg_ctr}%</div>
        </div>
        <div className="bg-nexus-surface p-5">
          <div className="label-eyebrow">$ per click</div>
          <div className="font-display font-black text-3xl mt-2 text-nexus-mint">
            ${totals.clicks > 0 ? (totals.spent / totals.clicks).toFixed(2) : "0.00"}
          </div>
        </div>
      </div>

      <div className="space-y-3">
        <div className="label-eyebrow">// top campaigns by impressions</div>
        <div className="space-y-px bg-white/5">
          {topCampaigns.length === 0 && <div className="bg-nexus-surface p-5 text-white/40 text-sm">No campaign data yet.</div>}
          {topCampaigns.map((c) => {
            const max = topCampaigns[0]?.impressions || 1;
            const w = Math.max(2, (c.impressions / max) * 100);
            return (
              <div key={c.id} className="bg-nexus-surface p-4">
                <div className="flex items-center justify-between mb-2">
                  <div className="text-sm font-medium truncate">{c.name}</div>
                  <div className="font-mono text-xs text-white/60">{(c.impressions || 0).toLocaleString()} impressions · {c.ctr}% CTR</div>
                </div>
                <div className="h-2 bg-white/5 overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-nexus-cyan to-nexus-violet" style={{ width: `${w}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
